jQuery(document).ready(function() {
    if (jQuery('footer.sg-styleguide-page').length) {
        var fb = jQuery('footer.sg-styleguide-page').position().top + jQuery('footer.sg-styleguide-page').height();
        var wb = jQuery(window).height();
        if (fb < wb) {
            jQuery('footer.sg-styleguide-page').css({
                'position': 'fixed',
                'bottom': '0',
                'width': '100%'
            });
        }
    }
});
